import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { Auditorialog } from "../types";
import { calcColorStatusAuditoriaLog, formatDateWithTime } from "@/shared";
import { Chip, ChipProps } from "@mui/material";

// Colores válidos para <Chip color="...">. Cualquier otro valor (ej. un HEX
// como "#0046FF") hace que MUI intente leer theme.palette[color].contrastText
// y reviente con "Cannot read properties of undefined (reading 'contrastText')".
const VALID_CHIP_COLORS: ChipProps["color"][] = [
  "default", "primary", "secondary", "error", "info", "success", "warning",
];

const toSafeChipColor = (color: unknown): ChipProps["color"] =>
  VALID_CHIP_COLORS.includes(color as ChipProps["color"])
    ? (color as ChipProps["color"])
    : "default";

export function useTableColumnsAuditorialog() {

  const columns = useMemo<MRT_ColumnDef<Auditorialog>[]>(
    () => [
      {
        id: 'endpoint',
        accessorKey: "endpoint",
        header: "Endpoint",
      },
      {
        id: 'accion',
        accessorKey: "accion",
        header: "Accion",
        Cell: ({ row }) => {
          const accion = row.original.accion ?? ""

          return (
            <Chip
              variant="outlined"
              color={toSafeChipColor(calcColorStatusAuditoriaLog(accion))}
              label={accion.toLocaleUpperCase() || "—"}
            />
          )
        }
      },
      {
        id: 'metodo_http',
        accessorKey: "metodo_http",
        header: "Metodo HTTP",
      },
      {
        id: 'modulo',
        accessorKey: "modulo",
        header: "Modulo",
      },

      {
        id: 'usuario_username',
        accessorKey: "usuario_username",
        header: "Usuario",
      },
      {
        id: 'fecha',
        accessorKey: "fecha",
        header: "Fecha",
        Cell: ({ row }) => formatDateWithTime(row.original.fecha)
      },
      {
        id: 'ip_address',
        accessorKey: "ip_address",
        header: "IP Address",
      },
      {
        id: 'estado_http',
        accessorKey: "estado_http",
        header: "Estado HTTP",
        Cell: ({ row }) => {
          const estado_http = row.original.estado_http

          return (
            <Chip
              variant="outlined"
              color={estado_http >= 200 && estado_http < 300 ? "success" : "error"}
              label={estado_http}
            />
          )
        }
      },
    ],
    []
  );

  return {
    columns
  };
}
